//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconVoice from './icons/voice'
import IconEmoji from './icons/emoji'
import IconMore from './icons/more'

export default {
  data () {
    return {
      showSend: false
    }
  },
  methods: {
    send (el) {
      const text = el.innerText
      if (text.length === 0) return
      console.log(text)
      this.$emit('send', text)
      el.innerText = ''
      this.showSend = false
    },
    input (el) {
      const text = el.innerText

      // 显示发送按钮
      this.showSend = text.length > 0
    }
  },
  components: {
    IconVoice,
    IconEmoji,
    IconMore
  }
}
